import { useMutation } from 'react-query';
import BankSlipReportService from './BankSlip.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

export function useBankSlipReport() {
  return useMutation(BankSlipReportService.getReportBankSlip, {
    onSuccess() {
      notification.success({
        message: 'Relatório de boleto bancário gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
